export let CommerceTool;
(function (CommerceTool) {
  CommerceTool["QUOTES"] = "quotes";
  CommerceTool["INVOICES"] = "invoices";
  CommerceTool["SUBSCRIPTIONS"] = "subscriptions";
  CommerceTool["PAYMENT_LINKS"] = "payment-links";
  CommerceTool["COMMERCE_HOME_PRE_ENROLL"] = "commerce-home-pre-enroll";
  CommerceTool["COMMERCE_HOME_POST_ENROLL"] = "commerce-home-post-enroll";
})(CommerceTool || (CommerceTool = {}));